import { useUser } from 'shared/hooks/use-user';

export const useUserInsights = () => {
  const user = useUser();

  return user?.settings?.insights;
};
